import { RuntimeStyle } from "@homebound/truss/runtime";

export function PdfCssReset() {
  return (
    <RuntimeStyle
      css={{
        html: `
          -webkit-font-smoothing: antialiased;
        `,
        body: `
          margin: 16px;
          background-color: white;
          color: rgba(53, 53, 53, 1);
          font-size: 14px !important;
          line-height: 20px !important;
        `,
        "@media print": `
          body {
            margin: 0;
          }
        `,
      }}
    />
  );
}
